import { create } from 'zustand'

interface User {
  id: string
  email: string
  name: string
}

interface LoginStatusState {
  // 登录状态
  isLoggedIn: boolean
  user: User | null

  // Actions
  login: (user: User) => void
  logout: () => void
}

export const useLoginStatusStore = create<LoginStatusState>((set) => ({
  // 初始状态
  isLoggedIn: false,
  user: null,

  // 登录操作
  login: (user: User) => set({
    isLoggedIn: true,
    user: user
  }),

  // 退出登录操作
  logout: () => set({
    isLoggedIn: false,
    user: null
  })
}))
